[
  "DDR3",
  "DDR4",
  "DDR5",
  "ECC",
  "NVMe",
  "PCIe",
  "SATA",
  "WiFi",
  "PoE",
  "USB",
  "Thunderbolt",
  "PCIe 3.0",
  "PCIe 4.0",
  "PCIe 5.0",
  "M.2",
  "SAS",
  "HDMI",
  "DisplayPort"
]
